export default function LinkIcon() {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g id="ic link">
            <path
               id="Vector 442"
               d="M10 7L11.5 5.5C13.433 3.567 16.567 3.567 18.5 5.5V5.5C20.433 7.433 20.433 10.567 18.5 12.5L17 14M14 17L12.5 18.5C10.567 20.433 7.433 20.433 5.5 18.5V18.5C3.567 16.567 3.567 13.433 5.5 11.5L7 10"
               stroke="currentColor"
               strokeWidth="2"
            />
            <path
               id="Vector 444"
               d="M9 15L15 9"
               stroke="currentColor"
               strokeWidth="2"
            />
         </g>
      </svg>
   )
}
